module.exports = __webpack_public_path__ + "static/media/ZESCAN.e5ccfc69.svg";